import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from './alert.component';

@NgModule({
   declarations: [AlertComponent],
   imports: [FormsModule, CommonModule],
   exports: [AlertComponent],
})
export class AlertModule {}
